module.exports = __webpack_public_path__ + "img/logos_fondo_blanco.1221a60a.svg";